




















































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import AppConsts from "@/lib/appconst";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
class PageCustomerStatementReportRequest {
  productId: number;
  warehouseCode: string;
  assetTypeCode: string;
  customerId: number;
  fromDate?: Date;
  toDate?: Date;
  pageSize: number;
  pageNumber: number;
}
@Component
export default class CustomerStatementReport extends mixins(
  ListMixin,
  AbpBase
) {
  namespace = "customerStatementReport";
  get store() {
    return this.$store.state.customerStatementReport;
  }
  //filters
  pagerequest: PageCustomerStatementReportRequest = new PageCustomerStatementReportRequest();
  creationTime: Date[] = [];
  reportResult = [];
  assetTypes = [];
  warehouses = [];
  spinShow: boolean = false;
  objectLoading: boolean = false;
  productName: string = "";
  customerType: string = "";
  customers = [];
  products = [];
  viewDateWarning() {
    var argus = [AppConsts.reportRangeDays.range180.toString()];
    return Util.L("RangeDaysTooltip", "", ...argus);
  }
  searchCustomer_OnPress = _.debounce(
    this.searchCustomerForSelect,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  searchProduct_OnPress = _.debounce(
    this.searchProductForSelect,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        this.$set(
          this.pagerequest,
          "warehouseCode",
          re.length === 0 ? "" : re[0].id
        );
        this.warehouses = re;
      });
  }
  async getAssetTypeServicesForSelect() {
    await this.$store
      .dispatch({
        type: "masterData/getAssetTypeServicesForSelect",
        data: {
          hasAllItem: true,
        },
      })
      .then((re) => {
        this.$set(
          this.pagerequest,
          "assetTypeCode",
          re.length === 0 ? "" : re[0].id
        );
        this.assetTypes = re;
      });
  }

  async exportToExcel() {
    this.buildPageRequest();
    await this.$store.dispatch({
      type: "report/exportCustomerStatement",
      data: this.pagerequest,
    });
  }
  buildPageRequest() {
    var warehouseCode = this.pagerequest.warehouseCode;
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.$store.state.session.tenant.tenancyName;
    }
    if (this.creationTime.length > 0) {
      this.pagerequest.fromDate = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.toDate = this.creationTime[1];
    }
    this.pagerequest.pageSize = this.pageSize;
    this.pagerequest.pageNumber = this.currentPage;
  }

  async searchCustomerForSelect(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.objectLoading = true;
    this.customers = await this.$store.dispatch({
      type: "customer/searchCustomerForSelect",
      data: {
        keyWord: keyword,
      },
    });
    this.objectLoading = false;
  }
  changeCustomer() {
    if (
      Util.isNull(this.pagerequest.customerId) ||
      this.pagerequest.customerId <= 0
    ) {
      this.customerType = "";
      return;
    }
    var cust = _.find(this.customers, ["id", this.pagerequest.customerId]);
    if (Util.isNull(cust)) {
      this.customerType = "";
      Util.showErrorMsg(this, "Error.ProductNotExist");
      return;
    }
    this.customerType = cust.typeName;
  }
  async searchProductForSelect(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    this.products = await this.$store.dispatch({
      type: "product/searchProductForSelect",
      data: {
        clientCode: "",
        keyWord: keyword,
      },
    });
    this.objectLoading = false;
  }
  changeProduct() {
    if (
      Util.isNull(this.pagerequest.productId) ||
      this.pagerequest.productId <= 0
    ) {
      this.productName = "";
      return;
    }
    var product = _.find(this.products, ["id", this.pagerequest.productId]);
    if (Util.isNull(product)) {
      this.productName = "";
      Util.showErrorMsg(this, "Error.ProductNotExist");
      return;
    }
    this.productName = product.name;
  }
  async getpage() {
    this.buildPageRequest();
    await this.$store
      .dispatch({
        type: `${this.namespace}/getAll`,
        data: this.pagerequest,
      })
      .catch(() => {
        this.store.loading = false;
      });
  }
  columns = [
    {
      title: Util.L("Order"),
      type: "index",
      width: 80,
    },
    {
      title: Util.L("TransDate"),
      width: 170,
      key: "transDate",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDatePickerString(params.row.transDate));
      },
    },
    {
      title: Util.L("RefCode"),
      width: 150,
      key: "refCode",
    },
    {
      title: Util.L("RefExternalCode"),
      width: 150,
      key: "refExternalCode",
    },
    {
      title: Util.L("ActionInOut"),
      width: 100,
      key: "actionType",
    },
    {
      title: Util.L("Warehouse"),
      width: 150,
      key: "warehouseName",
    },
    {
      title: Util.L("Client"),
      width: 150,
      key: "clientName",
    },
    {
      title: Util.L("ModelSku"),
      width: 150,
      key: "modelSKU",
    },
    {
      title: Util.L("SKU"),
      width: 150,
      key: "sku",
    },
    {
      title: Util.L("ProductName"),
      width: 150,
      key: "productName",
    },
    {
      title: Util.L("AssetType"),
      width: 150,
      key: "assetTypeName",
    },
    {
      title: Util.L("ConditionType"),
      width: 150,
      key: "conditionTypeName",
    },
    {
      title: Util.L("IncreaseQty"),
      width: 100,
      key: "increaseQty",
      align: "right",
      className: "increaseCell",
      render: (h: any, params: any) => {
        if (params.row.increaseQty > 0)
          return h("span", Util.toViewNumberString(params.row.increaseQty));
        return h("span", "");
      },
    },
    {
      title: Util.L("DecreaseQty"),
      width: 100,
      key: "decreaseQty",
      align: "right",
      className: "decreaseCell",
      render: (h: any, params: any) => {
        if (params.row.decreaseQty > 0)
          return h("span", Util.toViewNumberString(params.row.decreaseQty));
        return h("span", "");
      },
    },
  ];
  async created() {
    this.spinShow = true;
    try {
      if (!this.isTenant()) await this.getWarehouses();
      await this.getAssetTypeServicesForSelect();
      this.creationTime = Util.buildDefaultViewDate(
        AppConsts.reportRangeDays.range180
      );
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
